<template>
  <!-- 页脚 -->
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>易博数字</h3>
          <p>专业的工业互联网解决方案提供商</p>
        </div>
        <div class="footer-section">
          <h3>产品服务</h3>
          <p><a href="#">AIOT平台</a></p>
          <p><a href="#">能碳管理平台</a></p>
          <p><a href="#">企业数字化平台</a></p>
        </div>
        <div class="footer-section">
          <h3>解决方案</h3>
          <p><a href="#">智能制造</a></p>
          <p><a href="#">智慧冶金</a></p>
          <p><a href="#">智慧化工</a></p>
          <p><a href="#">智慧园区</a></p>
        </div>
        <div class="footer-section">
          <h3>联系我们</h3>
          <p>地址：济南市历下区山东人工智能产业园</p>
          <p>商务合作：15318821957</p>
          <p>方案咨询：18610282587</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>版权所有&copy; 山东易博数字数字科技有限公司. 鲁ICP备2025165981号-3</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
/* 页脚样式 */
.footer {
  background: #2c3e50;
  color: white;
  padding: 3rem 0 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-bottom: 2rem;
}

.footer-section h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #1e90ff;
}

.footer-section p {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.footer-section a {
  color: #bbb;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section a:hover {
  color: #1e90ff;
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: 1rem;
  text-align: center;
  color: #bbb;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
</style>